/**
 * @generated SignedSource<<8c9e11b737ff320e571770ad1f1a4ad3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareRequestsApproveMutation$variables = {
  accessRequestId: string;
};
export type ShareRequestsApproveMutation$data = {
  readonly approveNoteAccessRequest: {
    readonly note: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_sharedWith" | "ShareRequests_noteAccessRequests">;
    };
  } | null;
};
export type ShareRequestsApproveMutation = {
  response: ShareRequestsApproveMutation$data;
  variables: ShareRequestsApproveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accessRequestId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accessRequestId",
    "variableName": "accessRequestId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareRequestsApproveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApproveNoteAccessRequestMutation",
        "kind": "LinkedField",
        "name": "approveNoteAccessRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareRequests_noteAccessRequests"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareMeetingModal_sharedWith"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareRequestsApproveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ApproveNoteAccessRequestMutation",
        "kind": "LinkedField",
        "name": "approveNoteAccessRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteAccessRequestNode",
                "kind": "LinkedField",
                "name": "pendingAccessRequests",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "requestor",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGuest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isConfigured",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71f888e375127d5ddb540326982dc8b9",
    "id": null,
    "metadata": {},
    "name": "ShareRequestsApproveMutation",
    "operationKind": "mutation",
    "text": "mutation ShareRequestsApproveMutation(\n  $accessRequestId: ID!\n) {\n  approveNoteAccessRequest(accessRequestId: $accessRequestId) {\n    note {\n      id\n      ...ShareRequests_noteAccessRequests\n      ...ShareMeetingModal_sharedWith\n    }\n  }\n}\n\nfragment ShareMeetingModal_sharedWith on Note {\n  noteuserSet {\n    id\n    accessType\n    user {\n      id\n      email\n      fullName\n      image\n      isExternal\n      isGuest\n      isConfigured\n    }\n  }\n}\n\nfragment ShareRequests_noteAccessRequests on Note {\n  pendingAccessRequests {\n    id\n    createdAt\n    requestor {\n      id\n      fullName\n      email\n      image\n      isExternal\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "56789c7093931ae32cb3e0c08281664a";

export default node;
